import { render } from "./KanoonCourseApprovalCard.vue?vue&type=template&id=0b509976"
import script from "./KanoonCourseApprovalCard.vue?vue&type=script&lang=js"
export * from "./KanoonCourseApprovalCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"KanoonCourseApprovalCard.vue"]])

export default __exports__